<footer>
  <div class="footer">
    <div class="container">
      <div class="school-wrapper">
        <div class="image-wrapper">
          <img
            [src]="
              school.logo ? school.logo : '../assets/images/school-logo.svg'
            "
            alt="logo"
          />
        </div>
        <h1 class="school-name">
          {{ school.name }}
        </h1>
        <!-- <button (click)="openShareDialog()">Share</button> -->
      </div>
      <div class="contact">
        <div class="contactWrap">
          <div class="contact-logo">
            <img src="../../assets/images/call.png" />
          </div>
          <a
            [href]="'tel:+91' + (school?.contact?.mobile || '5555555555')"
            class="contact-link"
          >
            <p>+91 {{ school?.contact?.mobile || "555 555 5555" }}</p>
          </a>
        </div>
        <div class="contactWrap">
          <div class="contact-logo">
            <img src="../../assets/images/maillogo.png" />
          </div>
          <a
            [href]="
              'mailto:' + (school?.contact?.email || 'example@example.com')
            "
            class="contact-link"
          >
            <p>{{ school?.contact?.email }}</p>
          </a>
        </div>
        <button (click)="openShareDialog()">
          <mat-icon>share</mat-icon>
          Click to Share
        </button>
      </div>
    </div>
    <div class="school-info">
      <div class="info">
        <!-- <ul class="nav-links">
          <li (click)="scrollToSection('director-desk')">Principals's desk</li>
          <li (click)="scrollToSection('facilities')">Facilities</li>
          <li (click)="scrollToSection('sports')">Sports</li>
          <li (click)="downloadBrochure()">Download Brochure</li>
        </ul> -->
        <div class="address">
          <h3>{{ school?.name }}</h3>
          <p>
            {{ school?.address?.address }} {{ school?.address?.pincode }}
            {{ school?.address?.country }}
          </p>
        </div>
        <div class="links">
          <div class="links-card">
            <ng-container>
              <a
                [href]="school?.contact?.facebookPage"
                target="_blank"
                rel="noopener"
                class="links"
              >
                <img
                  src="../../assets/images/facebook.png"
                  alt="Social Icon"
                  class="social-icon"
                />
              </a>
            </ng-container>
          </div>
          <div class="links-card">
            <ng-container>
              <a
                [href]="school?.contact?.instagramPage"
                target="_blank"
                rel="noopener"
                class="links"
              >
                <img
                  src="../../assets/images/instagram.png"
                  alt="Social Icon"
                  class="social-icon"
                />
              </a>
            </ng-container>
          </div>
          <div class="links-card">
            <ng-container>
              <a
                [href]="school?.contact?.youtubeChannel"
                target="_blank"
                rel="noopener"
                class="links"
              >
                <img
                  src="../../assets/images/utube.png"
                  alt="Social Icon"
                  class="social-icon"
                />
              </a>
            </ng-container>
          </div>
          <div class="links-card">
            <ng-container>
              <a
                [href]="school?.contact?.twitterPage"
                target="_blank"
                rel="noopener"
                class="links"
              >
                <img
                  src="../../assets/images/twitter.png"
                  alt="Social Icon"
                  class="social-icon"
                />
              </a>
            </ng-container>
          </div>
        </div>
        <div class="timings">
          <h2>Working hours</h2>
          <div class="wrap">
            <p>MONDAY TO FRIDAY</p>
            <p>8.00 AM TO 4.00 PM</p>
          </div>
          <div class="wrap">
            <p>SATURDAY</p>
            <p>8.00 AM TO 1.00 PM</p>
          </div>
        </div>
      </div>
      <div class="map">
        <iframe
          class="map"
          [src]="mapUrl"
          width="100%"
          height="300"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
    <div class="love">Made with ❤️ in India</div>
  </div>
</footer>
